import { declareTheme } from "@component-library/themes";

export const useTheme = declareTheme({
  default: {
    text: 'text-sm text-secondary'
  },
  editor: {
    text: 'text-xs leading-4 text-neutral-500'
  }
})